let apiBaseUrl = () => {
  let baseUrl = ''
  if (process.env.NODE_ENV === 'development') {
    baseUrl = '/jxapi/'
  } else {
    if (window.location.origin.indexOf('testbc.sousoushenbian.com') > 0) {
      baseUrl = 'https://testbc.lingxingkj.net/'
    } else if (
      window.location.origin.indexOf('bcadmin.sousoushenbian.com') > 0
    ) {
      baseUrl = 'https://bc.sousoushenbian.com'
    } else if (window.location.origin.indexOf('admin.hxmeiwu.com') > 0) {
      baseUrl = 'https://testbc.lingxingkj.net'
    } else if (window.location.origin.indexOf('admin.hainanmeiwu.com') > 0) {
      baseUrl = 'https://apiback.hainanhongbao.com'
    } else if (window.location.origin.indexOf('admin.hongbaoliandong.com') > 0) {
      baseUrl = 'https://testbc.lingxingkj.net'
    } else if (window.location.origin.indexOf('admin.hainanhongbao.com') > 0) {
      baseUrl = 'https://apiback.hainanhongbao.com'
    }
  }
  return baseUrl
}
export const API_BASE_URL = apiBaseUrl()
